import { render, staticRenderFns } from "./registe.vue?vue&type=template&id=6934aa01&scoped=true"
import script from "./registe.vue?vue&type=script&lang=js"
export * from "./registe.vue?vue&type=script&lang=js"
import style0 from "./registe.vue?vue&type=style&index=0&id=6934aa01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6934aa01",
  null
  
)

export default component.exports